<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.manageFiling.origCourt.stepJudgments.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.manageFiling.origCourt.stepJudgments.description') }}
    </v-card-subtitle>
    <v-card-text class="pt-2">

      <transition-group name="scroll-y-transition" tag="div" style="width:100%">
        <v-row v-for="(judgment, index) in bean"
               :key="`judgmentGroup-${index}`"
               no-gutters
               align="center" justify="end">

          <v-col cols="11">
            <v-row no-gutters>
              <v-col v-if="index>0" :key="`col-judgment-divider-${index}`" cols="12" class="pb-6">
                <v-divider :key="`judgement-divider-${index}`"/>
              </v-col>
              <v-col cols="12">
                <c-text-field
                  v-model="judgment.judge"
                  :label="$t('page.manageFiling.origCourt.stepJudgments.field.judge')"
                  maxlength="250"
                  :key="`judge-${index}`"
                  outlined
                  hide-details="auto"
                  aria-describedby="8d224b6e-d19c-4ba0-b942-b917d572a4a7"/>
                <field-description id="8d224b6e-d19c-4ba0-b942-b917d572a4a7"
                                   message-key="page.manageFiling.origCourt.stepJudgments.field.judge.description"/>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-2">
                <c-autocomplete
                  v-model="judgment.judgmentType"
                  :items="judgmentTypes"
                  :label="$t('page.manageFiling.origCourt.stepJudgments.field.judgmentType')"
                  item-value="judgmentTypeID"
                  item-text="judgmentTypeValue"
                  return-object
                  :key="`judgment-type-${index}`"
                  outlined
                  hide-details="auto"
                  aria-describedby="cd0c6559-597b-4fae-9732-96bf2536e8dd"/>
                <field-description id="cd0c6559-597b-4fae-9732-96bf2536e8dd"
                                   message-key="page.manageFiling.origCourt.stepJudgments.field.judgmentType.description"/>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-2">
                <c-date-picker
                  v-model="judgment.judgmentDate"
                  :label="$t('page.manageFiling.origCourt.stepJudgments.field.judgmentDate')"
                  :key="`judgment-date-${index}`"
                  outlined
                  hide-details="auto"
                  aria-describedby="59a66d26-7694-42aa-9d83-aba5564e5b4f"/>
                <field-description id="59a66d26-7694-42aa-9d83-aba5564e5b4f"
                                   message-key="page.manageFiling.origCourt.stepJudgments.field.judgmentDate.description"/>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1" class="text-end">
            <v-btn v-if="shouldDisplayRemove" icon color="primary"
                   @click="removeJudgment($event, `${index}`)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </transition-group>
      <v-row no-gutters>
        <v-col cols="12">
          <c-btn @click="addAnotherJudgment">
            {{ $t('page.manageFiling.origCourt.stepJudgments.button.addAnotherJudgment') }}
          </c-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-end mt-5">
      <c-btn type="primary" @click="save">
        {{ editing ? $t('global.save') : $t('global.next') }}
      </c-btn>
      <c-btn v-if="!editing" @click="$emit('back')">
        {{ $t('global.back') }}
      </c-btn>
      <c-btn @click="$emit('cancel')">
        {{ $t('global.cancel') }}
      </c-btn>
    </v-card-actions>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import WorkflowStepMixin from '@/mixins/workflowStep';
import { focusNext } from '@/application/utility';

export default {
  mixins: [ WorkflowStepMixin ],
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    generateJudgmentBean: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      judgmentTypes: []
    };
  },
  computed: {
    shouldDisplayRemove () {
      return this.bean.length > 1;
    }
  },
  created () {
    if (this.bean.length === 0)
    {
      this.bean.push(this.generateJudgmentBean());
    }
  },
  methods: {
    loadData () {
      let judgmentURL = this.$cove.getAPI({ name: 'api.cms.origJudgmentTypes',
        query: { size: this.CONST.PAGING_MAX_SIZE } });

      return axios.get(judgmentURL)
        .then((response) => {
          this.judgmentTypes = _.orderBy(_.get(response, 'data', []), 'judgmentTypeValue');
        });
    },
    validate () {
      this.$cove.validation.clear();

      _.forEach(this.bean, (judgment, index) => {
        this.$cove.validation.date.rejectIfInvalid(judgment.judgmentDate,
          'page.manageFiling.origCourt.stepJudgments.field.judgmentDate', 'judgment-date-'+index);
      });
      return !this.$cove.validation.hasErrors();
    },
    save () {

      this.removeEmptyJudgments();

      let isValid = this.validate();
      if (!isValid)
      {
        this.scrollTo(this.CONST.ERROR_CONTAINER_SELECTOR);
      }
      else
      {
        this.$emit('save', this.bean);
      }
    },
    addAnotherJudgment ()
    {
      this.bean.push(this.generateJudgmentBean());
    },
    removeJudgment (e, index)
    {
      focusNext(e);
      this.bean.splice(index, 1);
    },
    removeEmptyJudgments () {
      _.remove(this.bean, this.isEmptyJudgment);
    },
    isEmptyJudgment (judgment) {
      return _.isNil(judgment.judge) && _.isNil(_.get(judgment, 'judgmentType.judgmentTypeID', null))
          && _.isNil(judgment.judgmentDate);
    }
  }
};
</script>